import React from 'react';
import styles from './GeoBlock.module.css';
import GeoLocationTester from '../GeoLocationTester/GeoLocationTester';

const GeoBlock = ({ location, onRetry }) => {
  const getBlockMessage = () => {
    if (location.isChina) {
      return {
        title: 'Service Not Available',
        message: 'Trakvu is not currently available in your region due to regulatory compliance requirements.',
        details: 'We apologize for the inconvenience. Our service is designed to comply with various international regulations and data protection laws.',
        showRetry: false
      };
    }
    
    return {
      title: 'Access Restricted',
      message: 'Our service is temporarily not available in your region.',
      details: 'We are working to expand our global availability while maintaining compliance with local regulations.',
      showRetry: true
    };
  };

  const blockInfo = getBlockMessage();

  return (
    <div className={styles.geoBlockContainer}>
      <div className={styles.geoBlockCard}>
        <div className={styles.iconContainer}>
          <i className="fas fa-globe-americas"></i>
        </div>
        
        <h1 className={styles.title}>{blockInfo.title}</h1>
        <p className={styles.message}>{blockInfo.message}</p>
        <p className={styles.details}>{blockInfo.details}</p>
        
        {blockInfo.showRetry && (
          <div className={styles.actions}>
            <button 
              className={styles.retryButton}
              onClick={onRetry}
            >
              <i className="fas fa-refresh"></i>
              Try Again
            </button>
          </div>
        )}
        
        <div className={styles.footer}>
          <p>
            If you believe this is an error, please contact our support team at{' '}
            <a href="mailto:support@trakvu.com" className={styles.supportLink}>
              support@trakvu.com
            </a>
          </p>
        </div>
      </div>
      
      <GeoLocationTester />
    </div>
  );
};

export default GeoBlock; 